export default __webpack_public_path__ + "static/media/27.59892e2d.gif";